
export default {
  data() {
    return {
      inView: false,
      category: [],
      categoryName: "",
      pageData: null,
      categories: null,
    };
  },
  watch: {
    $route: {
      handler() {
        this.changeCategory();
      },
    },
  },
  mounted() {
    this.changeCategory();
    this.$root.$on("categoryName", (data) => {
      this.categoryName = data;
    });
  },
  methods: {
    changeCategory() {
      this.$root.$on("categoryName", (data) => {
        this.categoryName = data;
      });
      if (this.$route && this.$route.query && this.$route.query.category) {
        this.category = [this.$route.query.category];
      } else {
        this.category = [];
        this.getCategories();
      }
    },
    async getCategories() {
      this.pageData = this.$parent.$parent.pageData;
      if (!this.category.length) {
        if (
          this.pageData &&
          this.pageData.components &&
          this.pageData.components.length &&
          this.pageData.components[0].linkMeta.categories
        )
          this.categories = await this.$getCategoriesInGroup(
            this.pageData.components[0].linkMeta.categories.replace(
              /(<([^>]+)>)/gi,
              ""
            )
          );
        // this.categories = await this.$getCategoriesInGroup("Articles");
        const category = [];
        for (let i = 0; i < this.categories.length; i++) {
          category.push(this.categories[i].slug);
        }
        this.category = category;
      }
    },
  },
};
